var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('OpsMetrics',{attrs:{"formattedMetrics":_vm.formattedMetrics,"metrics":_vm.metrics,"reviewData":_vm.reviewData,"accountsData":_vm.accountsData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }